<template>

<core-panel>

	<template v-slot:head>

		<h1>H-index</h1>

	</template>

	<template v-slot:body>

		<app-user type="player" :item="item" v-for="(item, index) in hindex" :subtext="item.plays + ' play' + ((item.plays > 1) ? 's' : '')" :key="index" :dark="true" />

	</template>

</core-panel>

</template>

<script>

import Panel from './../../common/Panel'

export default {

	mixins: [Panel],

	data: function() {

		return {
			detail: 'hindex',
			hindex: []
		}

	},

	methods: {

		response: function(json) {

			this.hindex = json.hindex.hindex

		}

	}

}

</script>